export default "__VITE_ASSET__BXdYw$Ps__"